module.exports = __webpack_public_path__ + "img/canada.4be3dbc8.svg";